import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Layout from "../../Layout";
import ShipCurrencymasterInput from "../../components/ShipCurrencymasterInput/ShipCurrencymasterInput";
import HeaderBread from "../../components/HeaderBread";
import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import { getSailingCurrency } from "../../utils/ApiCalls/SailingDates";

const EditSailingDate = () => {
  const params = useParams();
  const [activityCategory, setActivityCategory] = useState({});
  const [vesselData, setVesselData] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Currency",
      route: "/shore/mobile-masters/sailing_currency",
    },
    {
      title: "Edit Currency",
      route: "/shore/mobile-masters/sailing_currency/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getSailingCurrency({id:value});

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });

    setActivityCategory(data.data[0]);
    setVesselData(data?.vesselData);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Currency"}>
      <CustomHeaderTitle title={"Edit Currency"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Currency"}
      ></HeaderBread>
      {activityCategory && (
        <ShipCurrencymasterInput
          venus={activityCategory}
          vesselData={vesselData}
        />
      )}
    </Layout>
  );
};

export default EditSailingDate;
